import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import uuid from 'uuid/v4';
import { createInlineDecoration } from '../decoration/actions';
import { fetchAIParagraphs } from './api';
import { disableCheckForFailedChunksWithAnalytics, disableCheckForPurgedChunksWithAnalytics, fireAPIReceivedAnalytics, initiateProactiveAIWithAnalytics } from './commands-with-analytics';
import { regenerateAllDecorations } from './decorations';
import { createCommand, getPluginState } from './plugin-factory';
import { ACTIONS } from './states';
import { generateParagraphChunkMap, getAllDiffObjects, getBlocksSentencesNeedingSGCheck, getDiffObjectsForSuggestions, removeDiffObjectFromBlockMatchingText, removeSelectedDiffObjectFromBlock, setBlocksDiffObjects } from './utils';
export var insertSuggestion = function insertSuggestion(selectedDiff) {
  return createCommand(function (state) {
    var pluginState = getPluginState(state);
    var decorationSet = pluginState.decorationSet,
      currentInsertionCount = pluginState.insertionCount,
      proactiveAIBlocks = pluginState.proactiveAIBlocks;
    if (!proactiveAIBlocks || proactiveAIBlocks.length === 0) {
      return false;
    }
    var updatedProactiveAIBlocks = removeSelectedDiffObjectFromBlock(pluginState, selectedDiff.from, selectedDiff.to);
    return {
      type: ACTIONS.UPDATE_PLUGIN_STATE,
      data: {
        // Upon inserting a suggestion we need to ensure that that the insertion widget is removed.
        decorationSet: regenerateAllDecorations({
          decorationSet: decorationSet,
          tr: state.tr,
          pluginState: _objectSpread(_objectSpread({}, pluginState), {}, {
            proactiveAIBlocks: updatedProactiveAIBlocks
          })
        }),
        proactiveAIBlocks: updatedProactiveAIBlocks,
        insertionCount: currentInsertionCount + 1
      }
    };
  }, function (tr, state) {
    var schema = state.schema;
    var selection = tr.selection;
    if (selection.from === selection.to) {
      var _resolvedPos$nodeAfte;
      /**
       * mark transaction as suggestionAccepted, so that we can ignore update
       * 	while updating proactiveAIBlocks.
       */
      tr.setMeta('suggestionAccepted', true);
      var from = selectedDiff.from,
        to = selectedDiff.to,
        text = selectedDiff.text,
        replacement = selectedDiff.replacement;

      /**
       * Take the marks from the 'from' position
       * (beginning of the word to be replaced)
       *
       * This is to ensure that the new text has the same marks as the old text.
       * To be more pragmatic, we only look at 'from' position in case the
       * word has different mark combinations in each letter.
       */
      var resolvedPos = state.doc.resolve(from);
      var marks = ((_resolvedPos$nodeAfte = resolvedPos.nodeAfter) === null || _resolvedPos$nodeAfte === void 0 ? void 0 : _resolvedPos$nodeAfte.marks) || [];
      if (replacement) {
        tr.replaceWith(from, to, replacement);
        marks.forEach(function (mark) {
          tr.addMark(from, from + replacement.size, mark);
        });
        return tr;
      }
      return tr.replaceWith(from, to, schema.text(text, marks));
    }
    return tr;
  });
};
export var removeSuggestion = function removeSuggestion(originalText) {
  return createCommand(function (state) {
    var pluginState = getPluginState(state);
    var decorationSet = pluginState.decorationSet,
      proactiveAIBlocks = pluginState.proactiveAIBlocks,
      dismissedWords = pluginState.dismissedWords;
    if (!proactiveAIBlocks || proactiveAIBlocks.length === 0) {
      return false;
    }
    var updatedProactiveAIBlocks = removeDiffObjectFromBlockMatchingText(pluginState, originalText);
    return {
      type: ACTIONS.UPDATE_PLUGIN_STATE,
      data: {
        dismissedWords: dismissedWords.add(originalText),
        decorationSet: regenerateAllDecorations({
          decorationSet: decorationSet,
          tr: state.tr,
          pluginState: _objectSpread(_objectSpread({}, pluginState), {}, {
            proactiveAIBlocks: updatedProactiveAIBlocks
          })
        }),
        proactiveAIBlocks: updatedProactiveAIBlocks
      }
    };
  });
};
var createSpellingAndGrammarCommand = function createSpellingAndGrammarCommand(actionType, toggleCount) {
  return createCommand(function (state) {
    var pluginState = getPluginState(state);
    var isSpellingAndGrammarEnabled = pluginState.isSpellingAndGrammarEnabled,
      documentSGChecker = pluginState.documentSGChecker;
    if (documentSGChecker) {
      if (actionType === ACTIONS.START_SPELLING_AND_GRAMMAR) {
        documentSGChecker.start();
      } else {
        // if currently isSpellingAndGrammarEnabled is false then action is to enable
        //	so start whole document S+G check.
        if (!isSpellingAndGrammarEnabled) {
          documentSGChecker.start();
        }
        // if currently isSpellingAndGrammarEnabled is true then action is to disable
        //	so stop whole document S+G check.
        else {
          documentSGChecker.stop();
        }
      }
    }
    return _objectSpread({
      type: actionType
    }, actionType === ACTIONS.TOGGLE_SPELLING_AND_GRAMMAR_ENABLED ? {
      data: {
        toggleCount: toggleCount
      }
    } : {});
  }, function (tr) {
    return tr.setMeta('addToHistory', false);
  });
};
export var startSpellingAndGrammar = function startSpellingAndGrammar() {
  return createSpellingAndGrammarCommand(ACTIONS.START_SPELLING_AND_GRAMMAR);
};
export var toggleSpellingAndGrammar = function toggleSpellingAndGrammar(toggleCount) {
  return createSpellingAndGrammarCommand(ACTIONS.TOGGLE_SPELLING_AND_GRAMMAR_ENABLED, toggleCount);
};
export var disableNeedSpellingAndGrammar = function disableNeedSpellingAndGrammar(skippedChunkIds, transform) {
  return createCommand(function () {
    return {
      type: ACTIONS.DISABLE_NEED_SPELLING_AND_GRAMMAR,
      data: {
        skippedChunkIds: skippedChunkIds
      }
    };
  }, function (tr, state) {
    if (transform) {
      return transform(tr, state).setMeta('addToHistory', false);
    }
    return tr.setMeta('addToHistory', false);
  });
};
export var highlightSentence = function highlightSentence(sentence) {
  return createCommand(function (state) {
    var _getPluginState = getPluginState(state),
      decorationSet = _getPluginState.decorationSet;
    return {
      type: ACTIONS.UPDATE_PLUGIN_STATE,
      data: {
        decorationSet: decorationSet.add(state.doc, [createInlineDecoration(sentence.from, sentence.to)])
      }
    };
  }, function (tr) {
    return tr.setMeta('addToHistory', false);
  });
};
export var unhighlightSentence = function unhighlightSentence() {
  return createCommand(function (state) {
    var _getPluginState2 = getPluginState(state),
      decorationSet = _getPluginState2.decorationSet;
    return {
      type: ACTIONS.UPDATE_PLUGIN_STATE,
      data: {
        decorationSet: decorationSet.remove(decorationSet.find(undefined, undefined, function (spec) {
          return spec.key === 'inlineDecoration';
        }))
      }
    };
  }, function (tr) {
    return tr.setMeta('addToHistory', false);
  });
};
export var updateChunksWithDiffObjects = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(view, chunks, locale) {
    var pluginState, proactiveAIApiUrl, suggestionGenerator, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          pluginState = getPluginState(view.state);
          proactiveAIApiUrl = pluginState.proactiveAIApiUrl;
          suggestionGenerator = fetchAIParagraphs(view, proactiveAIApiUrl, locale)(chunks);
          if (suggestionGenerator) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return");
        case 5:
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context2.prev = 7;
          _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
            var suggestionState, suggestions, newPluginState, decorationSet, isFirstInitiatedEventSent, splitParagraphIntoSentences, proactiveAIBlocks, paragraphChunkMap, chunksDiffObjectsById, updatedProactiveAIBlocks, initiateAnalytics, updatePluginCommand, _newPluginState, insertionCount, dismissedWords, allDiffObjects;
            return _regeneratorRuntime.wrap(function _loop$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  suggestionState = _step.value;
                  _context.t0 = suggestionState.state;
                  _context.next = _context.t0 === 'cached' ? 4 : _context.t0 === 'parsed' ? 4 : _context.t0 === 'trackedDuration' ? 16 : _context.t0 === 'receivedChunkMetadata' ? 21 : _context.t0 === 'failed' ? 23 : _context.t0 === 'purged' ? 25 : 26;
                  break;
                case 4:
                  suggestions = suggestionState.suggestions;
                  newPluginState = getPluginState(view.state);
                  decorationSet = newPluginState.decorationSet, isFirstInitiatedEventSent = newPluginState.isFirstInitiatedEventSent, splitParagraphIntoSentences = newPluginState.splitParagraphIntoSentences, proactiveAIBlocks = newPluginState.proactiveAIBlocks;
                  if (proactiveAIBlocks) {
                    _context.next = 9;
                    break;
                  }
                  return _context.abrupt("break", 26);
                case 9:
                  paragraphChunkMap = generateParagraphChunkMap(proactiveAIBlocks, splitParagraphIntoSentences);
                  chunksDiffObjectsById = getDiffObjectsForSuggestions({
                    editorView: view,
                    suggestions: suggestions,
                    paragraphChunkMap: paragraphChunkMap
                  });
                  updatedProactiveAIBlocks = setBlocksDiffObjects(newPluginState, chunksDiffObjectsById);
                  initiateAnalytics = initiateProactiveAIWithAnalytics(uuid());
                  updatePluginCommand = createCommand(function () {
                    return {
                      type: ACTIONS.UPDATE_PLUGIN_STATE,
                      data: {
                        proactiveAIBlocks: updatedProactiveAIBlocks,
                        isFirstInitiatedEventSent: true,
                        decorationSet: regenerateAllDecorations({
                          decorationSet: decorationSet,
                          tr: view.state.tr,
                          pluginState: _objectSpread(_objectSpread({}, newPluginState), {}, {
                            proactiveAIBlocks: updatedProactiveAIBlocks
                          })
                        })
                      }
                    };
                  }, function (tr) {
                    return tr.setMeta('addToHistory', false);
                  });
                  /**
                   * If isFirstInitiatedEventSent is true, we have already sent the initialEvent
                   * so we don't need to send it again.
                   */
                  isFirstInitiatedEventSent ? updatePluginCommand(view.state, view.dispatch) : initiateAnalytics(updatePluginCommand)(view.state, view.dispatch);
                  return _context.abrupt("break", 26);
                case 16:
                  _newPluginState = getPluginState(view.state);
                  insertionCount = _newPluginState.insertionCount, dismissedWords = _newPluginState.dismissedWords;
                  allDiffObjects = getAllDiffObjects(_newPluginState); // Below is analytics for receiving step from S+G API.
                  fireAPIReceivedAnalytics({
                    view: view,
                    duration: suggestionState.duration,
                    totalSuggestions: allDiffObjects.length,
                    totalAcceptedSuggestions: insertionCount,
                    totalDismissedSuggestions: dismissedWords.size
                  });
                  return _context.abrupt("break", 26);
                case 21:
                  createCommand(function () {
                    return {
                      type: ACTIONS.UPDATE_CHUNK_METADATA,
                      data: {
                        chunkId: suggestionState.chunkId,
                        metadata: suggestionState.metadata
                      }
                    };
                  }, function (tr) {
                    return tr.setMeta('addToHistory', false);
                  })(view.state, view.dispatch);
                  return _context.abrupt("break", 26);
                case 23:
                  if (suggestionState.failedChunkIds.length > 0) {
                    disableCheckForFailedChunksWithAnalytics({
                      view: view,
                      failedChunkIds: suggestionState.failedChunkIds,
                      errors: suggestionState.errors,
                      reason: suggestionState.reason,
                      statusCode: suggestionState.statusCode
                    })(view.state, view.dispatch);
                  }
                  return _context.abrupt("break", 26);
                case 25:
                  if (suggestionState.purgedChunkIds.length) {
                    disableCheckForPurgedChunksWithAnalytics({
                      purgedChunkIds: suggestionState.purgedChunkIds,
                      totalParts: suggestionState.totalParts,
                      totalPurgedParts: suggestionState.totalPurgedParts
                    })(view.state, view.dispatch);
                  }
                case 26:
                case "end":
                  return _context.stop();
              }
            }, _loop);
          });
          _iterator = _asyncIterator(suggestionGenerator);
        case 10:
          _context2.next = 12;
          return _iterator.next();
        case 12:
          if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
            _context2.next = 17;
            break;
          }
          return _context2.delegateYield(_loop(), "t0", 14);
        case 14:
          _iteratorAbruptCompletion = false;
          _context2.next = 10;
          break;
        case 17:
          _context2.next = 23;
          break;
        case 19:
          _context2.prev = 19;
          _context2.t1 = _context2["catch"](7);
          _didIteratorError = true;
          _iteratorError = _context2.t1;
        case 23:
          _context2.prev = 23;
          _context2.prev = 24;
          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context2.next = 28;
            break;
          }
          _context2.next = 28;
          return _iterator.return();
        case 28:
          _context2.prev = 28;
          if (!_didIteratorError) {
            _context2.next = 31;
            break;
          }
          throw _iteratorError;
        case 31:
          return _context2.finish(28);
        case 32:
          return _context2.finish(23);
        case 33:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[7, 19, 23, 33], [24,, 28, 32]]);
  }));
  return function updateChunksWithDiffObjects(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var isSelectionInBlock = function isSelectionInBlock(from, to, block) {
  return block.from <= from && block.to >= from || block.from <= to && block.to >= to;
};
var getBlocksNeedingSpellAndGrammarCheck = function getBlocksNeedingSpellAndGrammarCheck(state) {
  var _getPluginState3 = getPluginState(state),
    proactiveAIBlocks = _getPluginState3.proactiveAIBlocks;
  if (!proactiveAIBlocks || !proactiveAIBlocks.length) {
    return [];
  }
  return proactiveAIBlocks === null || proactiveAIBlocks === void 0 ? void 0 : proactiveAIBlocks.filter(function (block) {
    return !!block.needSpellingAndGrammarCheck;
  });
};
var getBlocksNeedingSGCheck = function getBlocksNeedingSGCheck(state, currentBlocks) {
  var blocksNeedingSpellAndGrammarCheck = getBlocksNeedingSpellAndGrammarCheck(state);
  var _state$selection = state.selection,
    from = _state$selection.from,
    to = _state$selection.to;
  return blocksNeedingSpellAndGrammarCheck.filter(function (block) {
    var selectionInBlock = isSelectionInBlock(from, to, block);
    return currentBlocks ? selectionInBlock : !selectionInBlock;
  });
};
var getChunksNeedingSGCheck = function getChunksNeedingSGCheck(state, currentBlocks) {
  var pluginState = getPluginState(state);
  var splitParagraphIntoSentences = pluginState.splitParagraphIntoSentences;
  var blocksNeedingSpellAndGrammarCheck = getBlocksNeedingSGCheck(state, currentBlocks);
  return splitParagraphIntoSentences ? getBlocksSentencesNeedingSGCheck(blocksNeedingSpellAndGrammarCheck) : blocksNeedingSpellAndGrammarCheck;
};
/**
 * Wait Y (Y > X) seconds before triggering S+G prompt for current blocks.
 * That means,
 *  Author starts updating block and keeps updating for sometime.
 *  Then Author pauses for Y (Y > X) seconds then trigger S+G prompt.
 */
export var triggerSpellingAndGrammarCheckForCurrentBlocks = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(view, locale) {
    var chunks;
    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          /**
           * If selection is overlap with block and it's been more than Y seconds
           *  since it was last updated then send it for S+G prompt.
           * Ignore non current blocks, as they will be handled separately.
           */
          chunks = getChunksNeedingSGCheck(view.state, true);
          if (!chunks.length) {
            _context3.next = 4;
            break;
          }
          _context3.next = 4;
          return updateChunksWithDiffObjects(view, chunks, locale);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee2);
  }));
  return function triggerSpellingAndGrammarCheckForCurrentBlocks(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Wait X seconds before triggering S+G prompt for non current blocks.
 * That means,
 *  Author starts updating block, till cursor (or selection) is in the block,
 *    and S+G prompt hasn't been run since last update then,
 *    trigger S+G prompts after X seconds.
 */
export var triggerSpellingAndGrammarCheckForNonCurrentBlocks = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(view, locale) {
    var chunks;
    return _regeneratorRuntime.wrap(function _callee3$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          chunks = getChunksNeedingSGCheck(view.state, false);
          if (!chunks.length) {
            _context4.next = 4;
            break;
          }
          _context4.next = 4;
          return updateChunksWithDiffObjects(view, chunks, locale);
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee3);
  }));
  return function triggerSpellingAndGrammarCheckForNonCurrentBlocks(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();
export var createTriggerSpellingAndGrammarCheck = function createTriggerSpellingAndGrammarCheck(timings) {
  var triggerSpellingAndGrammarCheckForNonCurrentBlocksThrottled = throttle(triggerSpellingAndGrammarCheckForNonCurrentBlocks, timings.nonCurrentChunks);
  var triggerSpellingAndGrammarCheckForCurrentBlocksDebounced = debounce(triggerSpellingAndGrammarCheckForCurrentBlocks, timings.currentChunks, {
    maxWait: timings.currentChunksMaxWait
  });
  var triggerSpellingAndGrammarCheck = function triggerSpellingAndGrammarCheck(view, locale) {
    triggerSpellingAndGrammarCheckForNonCurrentBlocksThrottled(view, locale);
    triggerSpellingAndGrammarCheckForCurrentBlocksDebounced(view, locale);
  };
  var cancelDebouncedAndThrottledSpellingAndGrammarCheck = function cancelDebouncedAndThrottledSpellingAndGrammarCheck() {
    triggerSpellingAndGrammarCheckForNonCurrentBlocksThrottled.cancel();
    triggerSpellingAndGrammarCheckForCurrentBlocksDebounced.cancel();
  };
  return {
    triggerSpellingAndGrammarCheck: triggerSpellingAndGrammarCheck,
    cancelDebouncedAndThrottledSpellingAndGrammarCheck: cancelDebouncedAndThrottledSpellingAndGrammarCheck
  };
};